import { SafeReportMetadataResponse } from "../Conversion";

export type RowData = SafeReportMetadataResponse | { __loading: true };
export type GroupedRowData = RowData & {
  __group?: string;
  // Drives subheader ordering in the DataTable. Sections sort by this rather
  // than by the (alphabetical) group label, so e.g. "Open Quotes" precedes
  // "Open Indications".
  __groupOrder?: number;
};
export type LoadedReportRow = SafeReportMetadataResponse & {
  __group?: string;
  __groupOrder?: number;
};

export const isLoadingState = (data: RowData): data is { __loading: true } =>
  "__loading" in data;
